import {useCallback, useEffect, useState} from 'react';

import {workingHoursApi} from 'api';
import {Card, PredefinedNotifierType, DataWrapper, AssignmentSelectors} from 'components';
import {useApiData} from 'hooks';
import {WorkingHours as WorkingHoursType} from 'types';

import {BaseWorkingHours} from '../BaseWorkingHours';

export const AssignmentWorkingHours: React.FC = () => {
    const [groupId, setGroupId] = useState<string>(null);

    const {send: getWorkingHours, data: workingHours, loading: getLoading} = useApiData(workingHoursApi.getForAssignment, {
        notificationType: PredefinedNotifierType.FetchError
    });
    const loadWorkingHours = useCallback(() => getWorkingHours(groupId), [groupId, getWorkingHours]);

    const {send: updateWorkingHours, loading: updateLoading} = useApiData(workingHoursApi.updateForAssignment, {
        onSuccess: loadWorkingHours,
        notificationType: PredefinedNotifierType.Save
    });

    const handleSubmit = useCallback((formData: WorkingHoursType) => {
        updateWorkingHours(formData, groupId);
    }, [updateWorkingHours, groupId]);

    useEffect(() => {
        loadWorkingHours();
    }, [loadWorkingHours]);

    return (
        <div className='tw-relative'>
            <AssignmentSelectors
                selectedGroupId={groupId}
                onChange={setGroupId}
            >
                {({renderGroup}) => (
                    <div className='tw-mb-4 tw-inline-block tw-w-64'>
                        {renderGroup()}
                    </div>
                )}
            </AssignmentSelectors>
            <Card className='tw-mt-4'>
                <DataWrapper isLoading={getLoading || updateLoading}>
                    <BaseWorkingHours
                        workingHours={workingHours}
                        loading={getLoading || updateLoading}
                        onSubmit={handleSubmit}
                    />
                </DataWrapper>
            </Card>
        </div>
    );
};